<template>
  <div class="outterBox">
    <div>
      <breadcrumb :breadcrumb_link="newsroom_breadcrumb" />
    </div>

    <!--    <div class="row d-flex justify-content-center">-->
    <!--      <div>-->
    <!--        <img src="@/assets/images/Podohotel/about_headerimage.jpg" />-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="header">
      <h1 class="overlay">NEWSROOM</h1>
      <!--      <img src="@/assets/images/Podohotel/about_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>

    <div class="container">
      <div class="newsroom_body_header col-md-12">
        <h2 class="text-center"><strong>뉴스룸</strong></h2>
      </div>
    </div>

    <div class="container">
      <div class="row d-flex justify-content-center mt-5 mb-5">
        <div class="col-lg-12 text-center">
          <h4>
            <strong>{{ item !== null ? item.title : '' }}</strong>
          </h4>
          <p style="text-align: end">{{ item !== null ? item.date : '' }}</p>
          <hr />
          <div class="detailContent">
            <quillEditor class="content" :content="item !== null ? item.memo : ''" :options="editorOption" disabled>
            </quillEditor>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import boardService from '@/services/board.service';
import {ARTICLE_PROJETION, BOARD_ID} from '@/util/BoardConst';
import moment from 'moment';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.bubble.css';
import {quillEditor} from 'vue-quill-editor';
import MY_BID from '@/services/boardIds';
export default {
  name: 'newsroom01',
  components: {Breadcrumb, quillEditor},
  data() {
    return {
      item: null,
      newsroom_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'ABOUT',
        present: '뉴스룸',
      },
      editorOption: {
        theme: 'bubble',
      },
    };
  },
  async beforeCreate() {
    // {
    //   id: 0,
    //   title: '국내 최고 골프장에 선정된 핀크스 골프클럽',
    //   date: '2021-12-31',
    //   image: 'main_newsroom_sample01.jpg',
    // },

    const aList = await boardService.getArticleById(
      MY_BID.NEWSROOM,
      'BoardArticleDetailWithFiles',
      parseInt(this.$route.params.id),
    );
    console.log('alist', aList);
    const items = aList._embedded.boardArticles.map(x => ({
      id: x.id,
      title: x.title,
      date: moment(x.startDate).format('YYYY-MM-DD'),
      image: `${x.attachFiles[0]?.urlPath}${x.attachFiles[0]?.fileName}`,
      memo: x.memo,
    }));

    this.item = items[0];

    console.log('item', this.item);
  },

  mounted() {
    this.$store.dispatch('Display/changeName', {name: '뉴스룸'});
  },
};
</script>

<style scoped lang="scss">
.newsroom_body_header {
  margin-top: 40px;
  margin-bottom: 50px;
}
.detailContent {
  ::v-deep img {
    max-width: 100%;
    height: auto;
  }
  word-break: keep-all;
}

.outterBox {
  padding-top: 0rem;
}
.headerimage {
  width: 100%;
  margin: 0;
  content: url('~@/assets/images/common/newsroom_headerimage.jpg');
}

.header {
  position: relative;
  width: 100%;
  padding-top: 0rem;
  > img {
    width: 100%;
  }

  .overlay {
    padding-top: 0rem;
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}
@media (max-width: 992px) {
  .outterBox {
    padding-top: 5rem;
  }

  .header {
    display: none;
  }
}
</style>
